import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8412d37c")

_pushScopeId("data-v-8412d37c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Key:")
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "key-color earned" }),
  /*#__PURE__*/_createTextVNode("Income")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "key-color tax-threshold" }),
  /*#__PURE__*/_createTextVNode("Single / Married Allowance ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "key-color work" }),
  /*#__PURE__*/_createTextVNode("Deductions for Children & Mortgage Interest ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "key-color pension" }),
  /*#__PURE__*/_createTextVNode("Expenses & Pension Contributions, BIK Deductions ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "key-color second-earner" }),
  /*#__PURE__*/_createTextVNode("Second Earner’s Allowance ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "key-color remaining" }),
  /*#__PURE__*/_createTextVNode("Remaining Taxable Income ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")

  return (_openBlock(), _createBlock(_component_ion_grid, { class: "key-container" }, {
    default: _withId(() => [
      _createVNode(_component_ion_row, null, {
        default: _withId(() => [
          _createVNode(_component_ion_col, null, {
            default: _withId(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, {
            class: "key-wrapper",
            size: "11"
          }, {
            default: _withId(() => [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})